import * as types from './constants';

const initialState = {
  data: {},
  editLoading: false,
  errors_api: {}
};

const actions = {
  // Withdraw Unmasking Invitation
  [types.WITHDRAW_UNMASKING_INVITATION_REQUEST]: state => {
    const data = {
      ...state,
      editLoading: true
    };

    return { ...data };
  },

  [types.WITHDRAW_UNMASKING_INVITATION_DONE]: (state, { payload }) => {
    const data = {
      ...state,
      editLoading: false,
      data: payload,
      errors_api: {}
    };

    return { ...data };
  },

  [types.WITHDRAW_UNMASKING_INVITATION_FAILED]: (state, { payload }) => {
    const data = {
      ...state,
      editLoading: false,
      errors_api: payload
    };

    return { ...data };
  }
};

export default (state = initialState, action) => {
  if (actions[action.type]) return actions[action.type](state, action);
  return state;
};

